export function anchorlink (){
  $(function(){

    const innerLink = document.querySelectorAll('.innerLink');
    let off = 100;
    if (window.innerWidth < 769){
      let off = window.innerHeight * 8 / 100;
    }
    let option = 0;
    if(document.querySelector('.featurePage')){
      option = 66;
      if (window.innerWidth < 769){
        option = 112;
      }
    }

    if(!($('.topPage').length)){
      const urlHash = location.hash;
      if(urlHash){
          const hash = document.querySelector(urlHash);
          $('html,body').stop().scrollTop(0);
          let position = hash.getBoundingClientRect().top + window.pageYOffset - off - option;
          $('html,body').animate({scrollTop:position},1000);//引数topの値までスクロールさせる
          return false;
        }
    }


    [...innerLink].forEach(link => {
      link.addEventListener('click', ()=>{
        let anchor = document.querySelector(link.getAttribute('href'));
        let position = anchor.getBoundingClientRect().top + window.pageYOffset - off - option;
        $('html,body').animate({scrollTop:position},1000);//引数topの値までスクロールさせる
        return false;
      });
    });
  });
}
